import './index.scss'
import React from 'react'

interface Props {
  errorType?: string
  message?: any
  getData?: any
}

export default ({ errorType = '网络错误，', message, getData }: Props) => {
  return (
    <div className="error">
      <div className="img"></div>
      <p className="tip">
        {errorType}
        {getData ? (
          <span className="retry" onClick={getData}>
            点击重试
          </span>
        ) : null}
      </p>
      {message && <p className="msg">错误原因:{message}</p>}
    </div>
  )
}
